import { render, staticRenderFns } from "./InfoHazardousQuestionList.vue?vue&type=template&id=d47ae686&scoped=true"
import script from "./InfoHazardousQuestionList.vue?vue&type=script&lang=js"
export * from "./InfoHazardousQuestionList.vue?vue&type=script&lang=js"
import style0 from "./InfoHazardousQuestionList.vue?vue&type=style&index=0&id=d47ae686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47ae686",
  null
  
)

/* custom blocks */
import block0 from "./InfoHazardousQuestionList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports